import React, { useState, lazy } from 'react';
import { Section } from './ui/Section';
export function ProductPreview() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    title: 'El Patrón Base del Paseillo',
    image: 'https://cdn.magicpatterns.com/uploads/iHYX7F14SmTjvYeiiv5Kpz/WhatsApp_Image_2026-05-20_at_21.26.09_(2).webp'
  }, {
    title: 'Anatomía Completa del Braceo',
    image: 'https://cdn.magicpatterns.com/uploads/wdQfzEB1iyS1ByYEusjKWK/WhatsApp_Image_2026-05-20_at_21.26.09_(3).webp'
  }, {
    title: 'La Mecánica del Floreo en 3 Pasos',
    image: 'https://cdn.magicpatterns.com/uploads/dHgKjuLP8sFCNnkRKfQAme/WhatsApp_Image_2026-05-20_at_21.26.09_(1).webp'
  }, {
    title: '5 Formas de Explicar el Compás de 3',
    image: 'https://cdn.magicpatterns.com/uploads/bKu2KSXHrwWtANpZiVAyg5/WhatsApp_Image_2026-05-20_at_21.26.09.webp'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };
  return <Section data-id="element-247">
      <div className="max-w-6xl mx-auto" data-id="element-248">
        <div className="text-center mb-8" data-id="element-249">
          <div className="inline-block bg-gradient-to-r from-red-50 to-red-100 border border-red-200 rounded-full px-4 py-1.5 font-semibold mb-3 text-xs tracking-wider uppercase text-red-600" data-id="element-250">
            📸 VISTA PREVIA
          </div>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-brand-title mb-3" data-id="element-251">
            Mira el material por dentro
          </h2>
          <div className="font-heading text-brand-textMuted font-medium" data-id="element-252">
            {String(currentSlide + 1).padStart(2, '0')} /{' '}
            {String(slides.length).padStart(2, '0')}
          </div>
        </div>

        <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-black rounded-3xl p-6 md:p-12 relative overflow-hidden shadow-2xl" data-id="element-253">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/10 rounded-full blur-3xl" data-id="element-254"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-3xl" data-id="element-255"></div>

          <div className="relative" data-id="element-256">
            <div className="flex items-center justify-center gap-4 md:gap-8" data-id="element-257">
              <button onClick={prevSlide} className="hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all hover:scale-110 active:scale-95 backdrop-blur-sm border border-white/20 z-10 shrink-0" aria-label="Anterior" data-id="element-258">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-259">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-260" />
                </svg>
              </button>

              <div className="flex-1 flex justify-center" data-id="element-261">
                <div className="relative w-full max-w-[400px]" data-id="element-262">
                  <div className="relative aspect-[3/4] overflow-hidden" data-id="element-263">
                    {slides.map((slide, index) => {
                    const isActive = index === currentSlide;
                    return <div key={index} className={`absolute inset-0 transition-all duration-500 ease-out ${isActive ? 'opacity-100 scale-100 z-20' : 'opacity-0 scale-95 z-0 pointer-events-none'}`} data-id="element-264">
                          <div className="relative h-full w-full" data-id="element-265">
                            <img src={slide.image} alt={slide.title} className="w-full h-full object-contain rounded-2xl shadow-2xl border-4 border-white/10 bg-white" loading="lazy" decoding="async" data-id="element-266" />
                          </div>
                        </div>;
                  })}
                  </div>

                  <div className="mt-6 text-center px-4" data-id="element-267">
                    <h3 className="font-heading text-lg md:text-xl font-bold text-white drop-shadow-lg" data-id="element-268">
                      {slides[currentSlide].title}
                    </h3>
                  </div>
                </div>
              </div>

              <button onClick={nextSlide} className="hidden md:flex items-center justify-center w-12 h-12 rounded-full bg-gradient-red hover:opacity-90 text-white transition-all hover:scale-110 active:scale-95 shadow-red-glow z-10 shrink-0" aria-label="Siguiente" data-id="element-269">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-270">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-271" />
                </svg>
              </button>
            </div>

            <div className="flex md:hidden items-center justify-center gap-4 mt-8" data-id="element-272">
              <button onClick={prevSlide} className="flex items-center justify-center w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white transition-all active:scale-95 backdrop-blur-sm border border-white/20" aria-label="Anterior" data-id="element-273">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-274">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-275" />
                </svg>
              </button>
              <button onClick={nextSlide} className="flex items-center justify-center w-12 h-12 rounded-full bg-gradient-red hover:opacity-90 text-white transition-all active:scale-95 shadow-red-glow" aria-label="Siguiente" data-id="element-276">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-277">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-278" />
                </svg>
              </button>
            </div>

            <div className="flex items-center justify-center gap-2 mt-8" data-id="element-279">
              {slides.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`transition-all duration-300 rounded-full ${index === currentSlide ? 'w-8 h-2 bg-gradient-red shadow-red-glow' : 'w-2 h-2 bg-white/30 hover:bg-white/50'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-280" />)}
            </div>
          </div>
        </div>

        <p className="text-center text-brand-textMuted font-medium text-sm mt-6" data-id="element-281">
          Material real · Formato PDF profesional · Listo para usar en clase
        </p>
      </div>
    </Section>;
}